import {
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Capacitor } from '@capacitor/core';
import { environment } from '@marineform/environment';
import { Observable } from 'rxjs';

/**
 * WebView origin for the iOS manage shell (`iosScheme` + `hostname` in
 * `apps/manage/capacitor.config.ts`). CapacitorHttp does not attach it.
 */
const IOS_NATIVE_AUTH_ORIGIN = 'ionic://racapp.rentals';

/**
 * Sends HTTP with JSON content type and credentials.
 *
 * Session cookies must travel with authenticated service calls. This clone
 * applies to every request so callers do not set those options per service.
 * Native iOS calls to `auth` also send the WebView origin so state-changing
 * routes can accept them.
 */
export const CredentialsInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(
    req.clone({
      headers: headersFor(req),
      withCredentials: true,
    }),
  );
};

function headersFor(req: HttpRequest<unknown>): HttpHeaders {
  const headers = req.headers.set('Content-Type', 'application/json');
  if (
    Capacitor.getPlatform() === 'ios' &&
    req.url.startsWith(environment.authnBaseUrl)
  ) {
    return headers.set('Origin', IOS_NATIVE_AUTH_ORIGIN);
  }
  return headers;
}
